import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, CheckCircle } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    name: 'David',
    age: 33,
    location: 'Chicago, IL',
    headline: 'I regained the firmness I thought was gone',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=facearea&facepad=2.5&w=240&h=240&q=80',
    quote: "It wasn’t the same as before and I got scared. I felt like it was getting harder and harder for me, and I even thought my only way out was the blue pills, but I didn’t want to depend on that in my early thirties. Reading the book, I understood what my body and my daily routine were missing. I applied the changes to my diet and the recommended exercises, and the difference was total. My firmness is back to what it was when I was a kid, and the best part is that it’s natural. I feel an energy I haven't had in years."
  }, {
    name: 'Mateo',
    age: 25,
    location: 'Miami, FL',
    headline: 'I thought my sex life was over before it even started',
    avatar: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?auto=format&fit=facearea&facepad=2.5&w=240&h=240&q=80',
    quote: "It happened to me once and I wanted to die. Then it happened again and I went straight into a panic. I didn’t understand anything; at my age, this isn't supposed to happen, and you feel useless. I started avoiding going out with girls just out of fear of failing. I bought 'The Master Code' looking for a way out, and that’s when I understood that my problem wasn’t physical — stress was completely blocking me without me even realizing it. I applied the steps in the book, and after a few days, I felt my body responding for real again. It took a huge weight off my shoulders and I regained the confidence I had lost."
  }, {
    name: 'Ricardo',
    age: 53,
    location: 'Phoenix, AZ',
    headline: 'At 50, you can still perform like a lion',
    avatar: 'https://images.unsplash.com/photo-1545167622-3a6ac756afa4?auto=format&fit=facearea&facepad=2.5&w=240&h=240&q=80',
    quote: "Many told me that at this age 'it is what it is.' Lie. Understanding how my body works and optimizing my hormones naturally changed the rules of the game. Today I enjoy sex just like when I was young; my hardness and rigidity returned and I am very happy. Thank you."
  }, {
    name: 'Carlos',
    age: 28,
    location: 'Austin, TX',
    headline: 'Cheap dopamine had me blocked',
    avatar: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=facearea&facepad=2.5&w=240&h=240&q=80',
    quote: "I didn’t know it, but being on social media and watching porn all day was hurting me. When my girlfriend wanted intimacy, I would avoid her at all costs because my erection wasn't rock-solid anymore and I was terrified of failing. Thanks to the book, I understood that the problem wasn't her, nor was I broken; I just had to fix my habits. I followed the steps to the letter, and today my erections are back to what they used to be. My sex life is more active than ever and she can’t believe it."
  }, {
    name: 'Jorge',
    age: 41,
    location: 'Denver, CO',
    headline: 'New fire in my 15-year marriage',
    avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?auto=format&fit=facearea&facepad=2.5&w=240&h=240&q=80',
    quote: 'Routine and low energy were killing us. This protocol improved my blood flow, and Bonus 5 about volume provided a level of satisfaction that my wife and I didn’t expect.'
  }, {
    name: 'Sebastian',
    age: 37,
    location: 'Seattle, WA',
    headline: 'They told me it was just age-related fatigue',
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=facearea&facepad=2.5&w=240&h=240&q=80',
    quote: "I was always tired, and in bed, I simply wasn’t the same as before. My doctor told me it was 'normal' due to my lifestyle, but I didn’t resign myself to feeling this way at 37. Reading the book, I discovered that my body was completely drained of energy because I wasn't giving it what it needed. I made the changes they recommend, and I swear that after three weeks, I felt like a new man. I regained the power and the desire I thought weren't coming back. Thanks to this, my confidence and self-esteem returned."
  }];
  return <section className="py-24 px-6 bg-dark" data-id="element-216">
      <div className="max-w-7xl mx-auto" data-id="element-217">
        <FadeIn data-id="element-218">
          <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-219">
            <span className="text-gold tracking-[0.25em] text-xs md:text-sm uppercase mb-4 block font-semibold" data-id="element-220">
              Success Stories
            </span>
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-221">
              You are not alone. <br className="hidden md:block" data-id="element-222" />
              <span className="text-gold" data-id="element-223">More than 12,000 men</span> have
              already cracked the Code.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-224">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.05 * index} data-id="element-225">
              <div className="bg-dark-card p-7 rounded-lg relative h-full shadow-[0_20px_50px_-20px_rgba(0,0,0,0.7)] hover:border-gold/40 transition-colors duration-300 flex flex-col" style={{
            border: '1px solid #333'
          }} data-id="element-226">
                {/* Header: avatar + name + verified */}
                <div className="flex items-center gap-4 mb-5" data-id="element-227">
                  <div className="relative flex-shrink-0" data-id="element-228">
                    <div className="absolute inset-0 rounded-full bg-gold/20 blur-md" data-id="element-229"></div>
                    <img src={testimonial.avatar} alt={`${testimonial.name}, age ${testimonial.age}`} className="relative w-16 h-16 rounded-full object-cover ring-2 ring-gold/40 shadow-lg" data-id="element-230" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-231">
                    <p className="text-gold font-bold font-serif text-lg leading-tight" data-id="element-232">
                      {testimonial.name}
                      <span className="text-gold/60 font-sans font-normal text-sm ml-2" data-id="element-233">
                        · Age {testimonial.age}
                      </span>
                    </p>
                    <p className="text-gray-300 text-sm mt-0.5" data-id="element-234">
                      {testimonial.location}
                    </p>
                    <div className="flex items-center gap-1 mt-1" data-id="element-235">
                      <CheckCircle className="w-3 h-3 text-gold" data-id="element-236" />
                      <span className="text-gold/70 text-[10px] tracking-wider uppercase font-semibold" data-id="element-237">
                        Verified Client
                      </span>
                    </div>
                  </div>
                </div>

                {/* Stars */}
                <div className="flex gap-1 mb-4" data-id="element-238">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-239" />)}
                </div>

                {/* Story Headline */}
                <h3 className="font-serif text-gold text-lg md:text-xl font-bold leading-snug mb-3" data-id="element-240">
                  "{testimonial.headline}"
                </h3>

                {/* Quote */}
                <p className="text-gray-300 text-sm md:text-base italic leading-relaxed flex-1" data-id="element-241">
                  {testimonial.quote}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}